import 'detail/scss/_detail.scss'
import $ from 'jquery'
import MediaQueries from "media-queries"
import Mustache from 'mustache'
import {
   DkSlider
} from 'slider/js/slider'
import {
   CollectionTeaser
} from 'collection-teaser/js/collection-teaser'
import {
   DkMap
} from 'map/js/map'

//PolyFill
var URLSearchParams = require('url-search-params');

import "slick-carousel/slick/slick.scss"
import "slick-carousel/slick/slick-theme.scss"
import "slick-carousel/slick/slick.js"

const DETAIL_TEMPLATE = require('../assets/detail-template.html');
const MD_PROXY = require('proxy/proxy_config.js');

class MdDetail {
   constructor(elem) {
      const $this = $(elem);

      this.elem = elem;
      this.headlineLevel = $this.data("headline-level");
      this.objectId = $this.data("object-id");
      this.listUrl = $this.data("list-search-url");
      this.searchUrl = $this.data("search-url");
      this.ajaxUrl = $this.data("ajax-url");
      this.jsonSourceUrl = $this.data("ajax-url")+"&oges=" + this.objectId + "&output=json";
      this.assetUriObject = new URL( this.jsonSourceUrl );
      this.assetUri = this.assetUriObject.protocol + "//" + this.assetUriObject.host + "/";
      this.assetUriSubdomain = this.assetUriObject.hostname.split('.');
      this.assetUriSubdomain  = this.assetUriSubdomain.shift();
      this.showLiterature = $this.data("show-literature") === true ? true : false;
      this.showCollections = $this.data("show-collections") === true ? true : false;
      this.showMdlink = $this.data("show-mdlink") === true ? true : false;
      this.showMap = $this.data("show-map") === true ? true : false;

      //this.assetUri = this.assetUri + "data/"+this.assetUriSubdomain+"/"; //https://collectors.museum-digital.de/data/collectors/"
      this.searchUri = $this.data("search-url");
      //this.imagePath;
      this.slider;
      this.currentJson = {};
      this.accordions = [];
      //Text-Variables
      this.textVariables = {
         "rights": $this.data("text-rights"),
         "about": $this.data("text-about"),
         "inventorynumber": $this.data("text-inventorynumber"),
         "material": $this.data("text-material"),
         "dimensions": $this.data("text-dimensions"),
         "inscription": $this.data("text-inscription"),
         "patron": $this.data("text-patron"),
         "patronLink": $this.data("text-patron-link"),
         "classification": $this.data("text-classification"),
         "classificationText": $this.data("text-classification-text"),
         "tags": $this.data("text-tags"),
         "place": $this.data("text-place"),
         "tagSearchButton": $this.data("text-tag-search"),
         "literature": $this.data("text-literature"),
         "links": $this.data("text-links"),
         "collections": $this.data("text-collections"),
         "series": $this.data("text-series"),
         "seriesLink": $this.data("text-series-link"),
         "seriesLinkText": $this.data("text-series-link-text"),
         "detailLinkText": $this.data("text-detail-link-text"),
         "mdlink": $this.data("text-mdlink"),
         "mdlink-text": $this.data("text-mdlink-text"),
         "placeClassification": $this.data("text-place-classification"),
         "downloads": $this.data("text-downloads"),
         "feedback": $this.data("text-feedback"),
         "images": $this.data("text-images"),
         "error": $this.data("text-error"),
      }

      const resultXHR = this.get_ajax_result(this.jsonSourceUrl);
      $.when(resultXHR).then((result) => {

         $(this.elem).removeClass("loading");

         this.html_output(result);
      });

      this.init_events();
   }

   get_ajax_result(jsonUrl) {

      $(this.elem).addClass("loading");

      const objectlist = MD_PROXY.ajax(jsonUrl);

      this.currentJson = objectlist;
      return objectlist;
   }
   fixObjectLinks(){
      let linksObject = $(".literature.links a", this.elem);

      linksObject.toArray().map((singleLink, key) => {
         let url = new URL( $(singleLink).attr("href") );
         let md_url = new URL(this.jsonSourceUrl);
         let objectId = url.searchParams.get("oges");
         //prüfen ob lmw.museum-digital.de oder bawue.museum-digital.de
         if (objectId && (md_url.hostname === url.hostname)) {
            let newHref = "?dk_object_id=" + objectId;
            $(singleLink).attr("href", newHref);

         } else if (objectId) {
            //erstmal ignorieren, spezifischer Fall.
            /*
            const resolver = $.ajax({
               url: "https://lmw.museum-digital.de/resolver/object/md-bawue/" + objectId+"?noReferral=1",
               type: 'GET'
            });
            resolver.done((data) => {
               let url = new URL(data);
               let objectId = url.searchParams.get("oges");

               let newHref = "?dk_object_id=" + objectId;
               $(singleLink).attr("href", newHref);

            });
            */
         }

      });
   }
   html_output(result) {
      if (result.error !== "error") {
         const name = result.object_name,
            license = result.license,
            description = result.object_description.replace(new RegExp('\r?\n','g'), '<br />'),
            eventsObject = result.object_events,
            relationPlacesObject = result.object_relation_places,
            relationTimesObject = result.object_relation_times,
            relationPeopleObject = result.object_relation_people,
            collections = result.object_collection,
            dimensions = result.object_dimensions,
            inventorynumber = result.object_inventory_number,
            material = result.object_material_technique,
            inscription = result.inscription,
            type = result.object_type,
            tags = result.object_tags,
            series = result.object_series,
            institution = result.object_institution;

         let images = new Array();
         let mdCollections = new Array();
         let mdTags = new Array();
         let mdSeries = new Array();
         let mdlink = "";
         let mdMap = {
            latitude: "",
            longitude: "",
            zoom: "",
            markers: []
         };

         let literature = {
            "output": result.object_literature.length > 0 ? true : false,
            "entries": result.object_literature
         }
         let links = {
            "output": result.object_links.length > 0 ? true : false,
            "entries": result.object_links
         }

         let linksOrLiterature = false;
         if (result.object_literature.length > 0 || result.object_links.length > 0 && this.showLiterature === true) {
            linksOrLiterature = true;
         }

         let shareLinks = {
            "links": [{
                  "icon": "social-facebook",
                  "link": "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href),
                  "visibility": ""
               },
               {
                  "icon": "social-twitter",
                  "link": "https://twitter.com/home?status=" + encodeURIComponent(name + " " + window.location.href),
                  "visibility": ""
               },
               {
                  "icon": "social-whatsapp",
                  "link": "whatsapp://send?text=" + encodeURIComponent(name + " " + window.location.href),
                  "visibility": "hide-for-medium"
               },
               {
                  "icon": "social-whatsapp",
                  "link": "https://web.whatsapp.com/send?text=" + encodeURIComponent(name + " " + window.location.href),
                  "visibility": "show-for-medium"
               },
               {
                  "icon": "news-mail",
                  "link": "mailto:?subject=" + encodeURIComponent(name) + "&body=" + encodeURIComponent(window.location.href),
                  "visibility": ""
               }
            ]
         }

         //Die URLs jeweils in den View hängen.
         tags.map((tag, key) => {
            let tagURL = {
               tag_url: this.listUrl + "?ajax_url=" + encodeURIComponent(this.searchUri) + encodeURIComponent('&tag_id=' + tag.tag_id)
            };
            mdTags.push(Object.assign(tagURL, tag.tag_occurences, tag));
         });

         if(this.showCollections === true){
            mdCollections = {
               "output": collections.length > 0 ? true : false,
               "entries": new Array()
            }

            collections.map((collection, key) => {
               let collectionURL = {
                  collection_url: this.listUrl + "?search=true" + '&sammlungs_id=' + collection.collection_id,
                  detail_url: window.location.href
               };
               mdCollections["entries"].push(Object.assign(collectionURL, collection));
            });
         }

         if(this.showMdlink === true){
            mdlink = this.ajaxUrl+"&oges=" + this.objectId;
         }

         series.map((singleSeries, key) => {
            //console.log(this.listUrl + "?search=true" + '&sammlungs-id=' + singleSeries.series_id);
            let seriesURL = {
               series_url: this.listUrl + "?ajax_url=" + encodeURIComponent(this.searchUri) + encodeURIComponent('&serges=' + singleSeries.series_id),
               series_overview_url: this.listUrl + "?search=true" + '&serie_id=' + singleSeries.series_id,
               search_url: this.searchUrl,
               detail_url: window.location.href
            };
            mdSeries.push(Object.assign(seriesURL, singleSeries));
         });

         //Die Karte bevölkern.
         if (eventsObject.length > 0 || relationPlacesObject.length > 0) {
            let markers = new Array();
            $(eventsObject).toArray().map((eventObject, key) => {
               if (typeof eventObject.place !== 'undefined') {
                  //Default Zoom-Level is 4
                  let zoom = 4;
                  if (typeof eventObject.place.place_zoom !== 'undefined') {
                     zoom = eventObject.place.place_zoom;
                  }

                  let marker = {
                     latitude: eventObject.place.place_latitude,
                     longitude: eventObject.place.place_longitude,
                     zoom: zoom
                  };

                  markers.push(marker);
               }
            });
            $(relationPlacesObject).toArray().map((relationPlaceObject, key) => {
               if (typeof relationPlaceObject.place !== 'undefined') {
                  //Default Zoom-Level is 4
                  let zoom = 4;
                  if (typeof relationPlaceObject.place.place_zoom !== 'undefined') {
                     zoom = relationPlaceObject.place.place_zoom;
                  }
                  let marker = {
                     latitude: relationPlaceObject.place.place_latitude,
                     longitude: relationPlaceObject.place.place_longitude,
                     zoom: zoom
                  };

                  markers.push(marker);
               }
            });

            if (markers.length > 0 && this.showMap) {
               mdMap.latitude = markers[0].latitude;
               mdMap.longitude = markers[0].longitude;
               mdMap.zoom = markers[0].zoom;

               Object.assign(mdMap.markers, markers);
            } else {
               mdMap = false;
            }
         }


         //EvenetNamen anpassen, sodass kein gruscht mehr dransteht
         let correctedEventsObject = eventsObject.filter(function(object) {
            if (typeof object.event_name !== 'undefined') {
               let correctedName = object.event_name.substr(0, object.event_name.indexOf('---'));
               correctedName = correctedName.replace("[", "");
               correctedName = correctedName.replace("]", "");

               object.event_name = correctedName;
            }
            if (object.event_people_certain === "j" || object.event_people_certain === "") { //remove from JSON if its certain
               delete object.event_people_certain;
            }
            if (object.event_place_certain === "j" || object.event_place_certain === "") { //remove from JSON if its certain
               delete object.event_place_certain;
            }
            if (object.event_time_certain === "j" || object.event_time_certain === "") { //remove from JSON if its certain
               delete object.event_time_certain;
            }

            return object;
         });

         let correctedRelationPlacesObject = relationPlacesObject.filter(function(object) {
            if (typeof object.event_name !== 'undefined') {
               let correctedName = object.event_name.substr(0, object.event_name.indexOf('---'));
               correctedName = correctedName.replace("[", "");
               correctedName = correctedName.replace("]", "");

               object.event_name = correctedName;
            }
            return object;
         });

         let correctedRelationPeopleObject = relationPeopleObject.filter(function(object) {
            if (typeof object.event_name !== 'undefined') {
               let correctedName = object.event_name.substr(0, object.event_name.indexOf('---'));
               correctedName = correctedName.replace("[", "");
               correctedName = correctedName.replace("]", "");

               object.event_name = correctedName;
            }
            return object;
         });

         let correctedRelationTimesObject = relationTimesObject.filter(function(object) {
            if (typeof object.event_name !== 'undefined') {
               let correctedName = object.event_name.substr(0, object.event_name.indexOf('---'));
               correctedName = correctedName.replace("[", "");
               correctedName = correctedName.replace("]", "");

               object.event_name = correctedName;
            }
            return object;
         });

         const detailview = MD_PROXY.ajax(this.assetUri+"index.php?t=institution&instnr="+institution.institution_id+"&output=json");

         detailview.done((data) => {

            let subset = data.md_subset ? data.md_subset : data.subset;

            this.assetUri = this.assetUri + "data/"+subset+"/";

            //Add Data to the images
            result.object_images.map((singleImage, key) => {
               const image_owner = singleImage.owner;
               const image_description = singleImage.beschreibung;
               const image_name = singleImage.name;
               const image_creator = singleImage.creator;
               const image_rights = singleImage.rights;

               let imagePath;
               if (singleImage.filename_loc.startsWith("http") || singleImage.filename_loc.startsWith("HTTP")) {
                  imagePath = singleImage.filename_loc;
               } else {
                  imagePath = this.assetUri + singleImage.folder + "/" + singleImage.filename_loc;
               }

               let image = {
                  image_owner: image_owner,
                  image_description: image_description,
                  image_name: image_name,
                  image_creator: image_creator,
                  image_rights: image_rights,
                  imagePath: imagePath
               }

               images.push(image)
            });

            const view = {
               name: name,
               headlineLevel: this.headlineLevel,
               headlineLevel2: this.headlineLevel+1,
               headlineLevel3: this.headlineLevel+2,
               description: description,
               eventsObject: correctedEventsObject,
               collections: mdCollections,
               relationPlacesObject: correctedRelationPlacesObject,
               relationTimesObject: correctedRelationTimesObject,
               relationPeopleObject: correctedRelationPeopleObject,
               inventorynumber: inventorynumber,
               dimensions: dimensions,
               material: material,
               inscription: inscription,
               images: images,
               type: type,
               tags: mdTags,
               linksOrLiterature: linksOrLiterature,
               literature: literature,
               links: links,
               mdlink: mdlink,
               series: mdSeries,
               mdMap: mdMap,
               textVariables: this.textVariables,
               shareLinks: shareLinks
            }
            //console.log(correctedEventsObject);
            const detailHTML = Mustache.render(DETAIL_TEMPLATE, view);

            $(".detail-content", this.elem).prepend(detailHTML);

            this.initAccordions();
            this.initAddMailTo();
            //look at the links, search for oges, fix the links
            this.fixObjectLinks();
            //Init Sliders
            if ($('.slider', this.elem).length > 0) {
               $('.slider', this.elem).toArray().map((slider, key) => {
                  this.slider = new DkSlider(slider);
               })
            }

            //Init CollectionTeasers
            if ($('.collection-teaser', this.elem).length > 0) {
               $('.collection-teaser', this.elem).toArray().map((collectionTeaser, key) => {
                  new CollectionTeaser(collectionTeaser);
               })
            }

            if ($('.map-wrapper .map .map-container', this.elem).length > 0) {
               $('.map-wrapper .map .map-container', this.elem).toArray().map((mapInstance, key) => {
                  new DkMap(mapInstance);
               });
            }
         });
      } else {
         $(".detail-content", this.elem).append("<p class='error'>"+textVariables.error+"</p>");
      }
   }
   init_events() {

      $(this.elem).on("change", "input[type='checkbox']", (e) => {
         const currentInput = $($(e)[0].currentTarget);
         const inputID = currentInput.attr("id");

         if ($("#" + inputID).parents(".regular-tags").length > 0) {
            if ($("#" + inputID).prop("checked")) {
               $(".regular-tags input", this.elem).each(function(key, input) {
                  if ($(input).attr("id") !== inputID) {
                     $(input).prop("checked", false);
                  }
               });
            }
         } else if ($("#" + inputID).parents(".event-tags").length > 0) {
            if ($("#" + inputID).prop("checked")) {
               let selectedClass;
               if ($("#" + inputID).hasClass("people")) {
                  selectedClass = "people";
               }
               if ($("#" + inputID).hasClass("place")) {
                  selectedClass = "place";
               }
               if ($("#" + inputID).hasClass("time")) {
                  selectedClass = "time";
               }
               $(".event-tags ." + selectedClass, this.elem).each(function(key, input) {
                  if ($(input).attr("id") !== inputID) {
                     $(input).prop("checked", false);
                  }
               });
            }
         }

         let listURL = this.searchUri;
         let eventTags = $(".event-tags input[type='checkbox']:checked", this.elem);
         let regularTags = $(".regular-tags input[type='checkbox']:checked", this.elem);

         let event_id = "";
         let tag_id = "";

         $(eventTags).each((key, eventTag) => {
            if (typeof $(eventTag).data("id") !== 'undefined') {

               if ($(eventTag).hasClass("time")) {
                  event_id += "&zeit_id=" + $(eventTag).data("id");
               } else if ($(eventTag).hasClass("people")) {
                  event_id += "&persinst_id=" + $(eventTag).data("id");
               } else if ($(eventTag).hasClass("place")) {
                  event_id += "&ort_id=" + $(eventTag).data("id");
               }

            }
         })

         if (typeof regularTags.data("id") !== 'undefined') {
            tag_id = "&tag_id=" + regularTags.data("id");
         }
         listURL += encodeURI(event_id + tag_id);

         if (event_id !== "" || tag_id !== "") {
            const data = {
               url: listURL
            }

            const objectlist = MD_PROXY.ajax(listURL);

            objectlist.done((data) => {
               let json;

               if (typeof(data) === 'object') {
                  json = data;
               } else {
                  json = JSON.parse(data);
               }

               $(".object-tags .button .count", this.elem).html("("+json[0].total+")");
               //console.log(json.length);
            })

            objectlist.fail((data) => {
               //Error Handling?
            })
         } else {
            $(".object-tags .button .count", this.elem).html("");
            $(".object-tags .button", this.elem).attr("disabled", "disabled");
         }

      });

      $(this.elem).on("click", "input[type='checkbox'] + label", (e) => {
         $(".object-tags .button", this.elem).removeAttr("disabled");
      });

      $(this.elem).on("click", ".magnify", (e) => {
         e.preventDefault();

         $(".object-images .slider .slick-current a", this.elem)[0].click();
      });

      $(this.elem).on("click", ".object-tags .button", (e) => {
         e.preventDefault();
         const eventTags = $(".event-tags input[type='checkbox']:checked", this.elem);
         const regularTags = $(".regular-tags input[type='checkbox']:checked", this.elem);
         const listUrlArray = this.listUrl.split("?");
         let listUrlParams = new URLSearchParams(listUrlArray[1]);

         let event_id = "";
         let tag_id = "";

         $(eventTags).each((key, eventTag) => {
            if (typeof $(eventTag).data("id") !== 'undefined') {

               if ($(eventTag).hasClass("time")) {
                  event_id += "&zeit_id=" + $(eventTag).data("id");
                  listUrlParams.set("zeit_id", $(eventTag).data("id"));
               } else if ($(eventTag).hasClass("people")) {
                  event_id += "&persinst_id=" + $(eventTag).data("id");
                  listUrlParams.set("persinst_id", $(eventTag).data("id"));
               } else if ($(eventTag).hasClass("place")) {
                  event_id += "&ort_id=" + $(eventTag).data("id");
                  listUrlParams.set("ort_id", $(eventTag).data("id"));
               }

            }
         })

         if (typeof regularTags.data("id") !== 'undefined') {
            tag_id = "&tag_id=" + regularTags.data("id");
            listUrlParams.set("tag_id", regularTags.data("id"));
         }
         listUrlParams.set("search", true);
         location.href = listUrlArray[0] + "?" + listUrlParams.toString();
      });

      $(this.elem).on("click", ".share", (e) => {
         e.preventDefault();
         const currentElemment = $(e.currentTarget);
         currentElemment.addClass("open");
      });

      $(this.elem).on("click", ".icon-block .close", (e) => {
         e.preventDefault();
         $(".icon-block .share", this.elem).removeClass("open");
      });
      $(this.elem).on("click", ".backlink", (e) => {
         e.preventDefault();
         history.back();
      });
      //Helper-Variablen um sich zu merken ob es einen Breakpointwechsel gab oder nicht und ein throttle, sodass nicht ständig ein Abfrage abgefeuert wird.
      let resizeTimer;
      let sizeFlag;

      $(window).on('resize', (e)=> {

         clearTimeout(resizeTimer);
         resizeTimer = setTimeout( () => {
            if(window.innerWidth < MediaQueries.mediumBreakpoint){
               //Do it only once until there is a breakpoint change
               if(sizeFlag!="small"){
                  //Small Breakpoint
                  $(this.accordions).each((i,accordion) => {
                     $(".accordion-group__accordion", accordion).each((j,accordionPanel)=>{
                        //Only toggle opened
                        if($(accordionPanel).hasClass("accordion-group__accordion_expanded")){
                           $(accordion).ariaAccordion('toggleNoAnimate', $(accordionPanel));
                        }
                     })
                     sizeFlag = "small";
                  })
               }

            }else{
               //Do it only once until there is a breakpoint change
               if(sizeFlag!="large"){
                  //Large Breakpoint
                  $(this.accordions).each((i,accordion) => {
                     $(".accordion-group__accordion", accordion).each((j,accordionPanel)=>{
                        //Only toggle closed
                        if(!$(accordionPanel).hasClass("accordion-group__accordion_expanded")){
                           $(accordion).ariaAccordion('toggleNoAnimate', $(accordionPanel));
                        }
                     })
                  })
                  sizeFlag = "large";
               }
            }
            // Run code here, resizing has "stopped"
                     
         }, 250);

      });


   }

   initAccordions() {
      $(this.elem).on('ariaAccordion.slideDown', window, function(event, accordionGroup, index){
        console.log('Accordion ' + index + ' in accordion group ' + accordionGroup.element + ' was expanded');
      });
      this.accordions = $(".accordion-group", this.elem).ariaAccordion();
   }
   initAddMailTo() {
      //Add Subject and text to Mailto Links
      if ($(".generated-mailto", this.elem).length > 0) {
         $(".generated-mailto", this.elem).each((key, mail) => {
            const currHref = $(mail).attr("href");
            const objectName = this.currentJson.responseJSON.object_name;
            const objectInventoryNumber = this.currentJson.responseJSON.object_inventory_number;
            const currentUrl = window.location.href;
            const getParamSeperator = currHref.indexOf("?") !== -1 ? "&" : "?";

            $(mail).attr("href", currHref + getParamSeperator + "subject=" + encodeURIComponent("Sammlung Online " + objectName + " " + objectInventoryNumber) + "&body=" + encodeURIComponent(currentUrl));
         });
      }
   }
}

class MdDetailManager {
   constructor() {
      this.mdDetails = $('.md-detail').toArray().reduce((a, e) => ({
         [e]: new MdDetail(e),
         ...a
      }), {});
   }
}

$(function() {
   if ($('.md-detail').length > 0) {
      Mustache.parse(DETAIL_TEMPLATE);
      const mdDetail = new MdDetailManager();
   }
});